import { FilterFn } from '@tanstack/react-table'

export const dateBetweenFilter: FilterFn<any> = (row, columnId, filterValue, addMeta) => {
    const rowDate = new Date(row.getValue(columnId)).getTime()
    const [start, end] = filterValue  // both should be Date objects or timestamps

    return (
        (!start || rowDate >= new Date(start).getTime()) &&
        (!end || rowDate <= new Date(end).getTime())
    )
}
